export default {
  placeholder: '请选择',
};
